import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Lock } from 'lucide-react';
import './TosModal.css'; // Reusing the same modal styling for consistency

const PrivacyModal = ({ onClose }) => {
  return (
    <AnimatePresence>
      <motion.div 
        className="tos-modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div 
          className="tos-modal-content"
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.9 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button className="tos-close-btn" onClick={onClose}>
            <X size={24} />
          </button>

          <div className="tos-header">
            <div className="tos-icon-circle" style={{ background: 'rgba(0, 255, 136, 0.1)', color: '#00ff88' }}>
              <Lock size={32} />
            </div>
            <h2>Privacy <span className="text-gradient">Policy</span></h2>
            <p>Your Data & Security</p>
          </div>

          <div className="tos-body">
            <section className="tos-section">
              <h3>1. Data Collection (Discord)</h3>
              <p>When you connect your Discord account, we collect basic profile information including your <strong>Discord ID, Username, and Avatar</strong>. This is used solely to verify your identity, manage your optimization requests, and provide support in our server.</p>
            </section>

            <section className="tos-section">
              <h3>2. Usage Data (Tweaking Tool)</h3>
              <p>Our optimization tools and remote support software (such as AnyDesk) may temporarily log your <strong>IP Address</strong> and basic <strong>System Hardware Specifications</strong>. This data is used to ensure the security of the connection and to provide the correct optimizations for your specific hardware.</p>
            </section>

            <section className="tos-section">
              <h3>3. Data Storage</h3>
              <p>Your request history and basic profile data are stored securely via Supabase. We do not sell, trade, or otherwise transfer your information to outside parties.</p>
            </section>

            <section className="tos-section">
              <h3>4. Third-Party Links</h3>
              <p>Our website and tools may contain links to third-party software (e.g., NVIDIA, DDU). These third-party sites have separate and independent privacy policies. We have no responsibility or liability for the content and activities of these linked sites.</p>
            </section>

            <section className="tos-section">
              <h3>5. Consent</h3>
              <p>By using our website and services, you consent to our privacy policy and the collection of the data points mentioned above.</p>
            </section>
          </div>

          <div className="tos-footer">
            <button className="tos-understand-btn" style={{ background: '#00ff88' }} onClick={onClose}>Close</button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default PrivacyModal;
